'use strict';

function getImageAt(images, index) {
	if (!images || !images[index] || !images[index].url) {
		return null;
	}
	return images[index];
}

function getLastImageAt(images) {
	if (!images || !images.length) {
		return null;
	}
	return getImageAt(images, images.length - 1);
}

function resolveFromImageModel(images) {
	if (!images) {
		return null;
	}

	// medium, then large. small is left out: ProductCard_Small is too low-res for these slots.
	const mediumImages = images.medium || [];
	const largeImages = images.large || [];
	const mainImage = getLastImageAt(mediumImages) || getLastImageAt(largeImages);
	const mainLargeImage = getLastImageAt(largeImages) || mainImage;

	if (!mainImage || !mainLargeImage || !mainLargeImage.url) {
		return null;
	}

	return {
		image: mainImage,
		largeImage: mainLargeImage,
		src: mainLargeImage.url,
		alt: mainImage.alt || '',
		title: mainImage.title || ''
	};
}

module.exports = {
	getImageAt: getImageAt,
	getLastImageAt: getLastImageAt,
	resolveFromImageModel: resolveFromImageModel
};
